<template>
    <div class="wrapper_home mg_top">
        <div class="live_room">
            <div class="container ner_responesize ner_responesize_home">
                <div class="row">
                    <div class="col-md-9 col-sm-9 col-xs-9 video_live_left">
                        <div class="root_liveRoom" v-if="listLiveHome.length > 0">
                            <div :class="{active_margin: listLiveHome.length > 0}">
                                <div class="wrapper_liveroom">
                                    <div class="video_live_room" v-for="(item, index) in listLiveHome.slice(0, 1)" v-bind:key="index">
                                        <div class="wplive_home">
                                            <div class="video_f8live_home">
                                                <div v-if="item.device == 1" class="desktop_stream wrapper_video">
                                                    <div class="videotvc_adv" v-if="checkClickAdv == 0">
                                                        <video controls autoplay loop muted webkit-playsinline playsinline>
                                                            <source :src="link_tvc" type="video/mp4">
                                                        </video>
                                                        <span class="nextvideo nextvideo_home" @click="nextVideo">Bỏ qua</span>
                                                    </div>
                                                    <iframe v-else width="100%" class="iframe_videof8" :src="item.luong + '?playsinline=1'" title="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
                                                </div>
                                                <div v-else class="mobile_stream">
                                                    <div class="videotvc_adv" v-if="checkClickAdv == 0">
                                                        <video controls autoplay loop muted webkit-playsinline playsinline>
                                                            <source :src="link_tvc" type="video/mp4">
                                                        </video>
                                                        <span class="nextvideo nextvideo_home" @click="nextVideo">Bỏ qua</span>
                                                    </div>
                                                    <iframe v-else width="" height="533" class="iframe_videof8" :src="item.luong + '?playsinline=1'" title="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
                                                </div>
                                            </div>
                                            <router-link class="room_live_a" :data_device="item.device" v-bind:to="{ name: 'LiveDetail_nm', params: { id: item.id, idlive: item.id_live } }" v-if="checkClickAdv == 1" @click="getLocalstoragePage">Vào phòng live</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="root_liveRoom" v-else>
                            <div class="tvc_f8game_home">
                                <video width="100%" height="653" autoplay muted loop controls class="video-highlight-home" style="width: 100%;" webkit-playsinline playsinline>
                                    <source :src="link_tvc" type="video/mp4">
                                </video>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-3 col-xs-3 rank_idol_right">
                        <div class="wrapper_rank">
                            <h3>
                                <img src="../assets/images/bxh.png" alt="">
                                <span>Bảng xếp hạng</span>
                            </h3>
                            <div class="list_rank_home" :class="{active: check_deveci==1}" v-if="country == 'Vietnam'">
                                <ul>
                                    <li v-for="(item, index) in listBxhs" :key="index">
                                        <router-link v-bind:to="{ name: 'InfoIdol_nm', params: { id: item.id } }">
                                            <p class="stt_rank">{{ index + 1}}ST</p>
                                            <p class="img_rank_idol">
                                                <img :src="link_web + item.hinh_anh" alt="" v-if="item.hinh_anh !== null" class="img_tron">
                                                <img src="../assets/images/user.png" alt="" v-else class="img_tron">
                                            </p>
                                            <p class="name_idol_rank">{{ item.name }}</p>
                                            <img src="../assets/images/live.png" alt="" v-if="item.live == 1" class="img_live_rank">
                                            <img src="../assets/images/off.png" alt="" v-else class="img_live_rank">
                                        </router-link>
                                    </li>
                                </ul>
                                <p class="view_rank_detail">
                                    <router-link to="/list-idol">Xem thêm</router-link>
                                </p>
                            </div>
                            <div class="list_rank_home active right_cam" v-else>
                                <ul>
                                    <li v-for="(item, index) in listBxhs" :key="index">
                                        <router-link v-bind:to="{ name: 'InfoIdol_nm', params: { id: item.id } }">
                                            <p class="stt_rank">{{ index + 1}}ST</p>
                                            <p class="img_rank_idol">
                                                <img :src="link_web + item.hinh_anh" alt="" v-if="item.hinh_anh !== null" class="img_tron">
                                                <img src="../assets/images/user.png" alt="" v-else class="img_tron">
                                            </p>
                                            <p class="name_idol_rank">{{ item.name }}</p>
                                            <img src="../assets/images/live.png" alt="" v-if="item.live == 1" class="img_live_rank">
                                            <img src="../assets/images/off.png" alt="" v-else class="img_live_rank">
                                        </router-link>
                                    </li>
                                </ul>
                                <p class="view_rank_detail">
                                    <router-link to="/list-idol">Xem thêm</router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container ner_responesize">
            <!-- Chơi game -->
            <div class="wrapper_idol_live_home wrapper_idol_live_home0" v-if="listLiveHome.length > 0">
                <div class="title_item_idol">
                    <h3>
                        <img src="../assets/images/cg.png" alt="">
                        <span>Idol live</span>
                        <a @click="showModal = true" v-if="token==null">Xem thêm</a>
                        <router-link to="/live" v-else>Xem thêm</router-link>
                    </h3>
                </div>
                <div class="root_item_idol">
                    <Carousel :wrap-around="false" :breakpoints="breakpoints">
                        <Slide v-for="(item, indexs) in listLiveHome.slice(0,10)" :key="indexs">
                            <div class="item_live item_live_97">
                                <div class="img_live rela_img">
                                    <router-link v-bind:to="{ name: 'LiveDetail_nm', params: { id: item.id, idlive: item.id_live } }" @click="getLocalstoragePage">
                                        <img :src="link_web + item.background" alt="" v-if="item.background != null">
                                        <img src="../assets/images/lv.png" alt="" v-else>
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </router-link>
                                </div>
                                <div class="text_item_live">
                                    <router-link v-bind:to="{ name: 'LiveDetail_nm', params: { id: item.id, idlive: item.id_live } }" @click="getLocalstoragePage">
                                        <div class="img_live_small">
                                            <img :src="link_web + item.hinh_anh" alt="" v-if="item.hinh_anh != null">
                                            <img src="../assets/images/gx.png" alt="" v-else>
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item.fullname }}</h3>
                                            <div class="type_live">
                                                <p>
                                                    <img src="../assets/images/eye.svg" alt="">
                                                    <span class="sp-02">{{ item.total_view }}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <img src="../assets/images/live.png" alt="" class="img_live_green">
                                    </router-link>
                                </div>
                            </div>
                        </Slide>
                        <template #addons>
                            <Pagination />
                        </template>
                    </Carousel>
                </div>
                <div class="list_idol_mobile_live">
                    <div class="row">
                        <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" v-for="(item, index) in listLiveHome.slice(0,6)" :key="index">
                            <div class="item_live">
                                <router-link v-bind:to="{ name: 'LiveDetail_nm', params: { id: item.id, idlive: item.id_live } }" @click="getLocalstoragePage">
                                    <div class="img_live">
                                        <img :src="link_web + item.background" alt="" v-if="item.background != null">
                                        <img src="../assets/images/lv.png" alt="" v-else>
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="link_web + item.hinh_anh" alt="" v-if="item.hinh_anh != null">
                                            <img src="../assets/images/gx.png" alt="" v-else>
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item.fullname }}</h3>
                                            <div class="type_live">
                                                <p>
                                                    <img src="../assets/images/eye.svg" alt="">
                                                    <span class="sp-02">{{ item.total_view }}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="detail_mobile_a">
                    <router-link to="/live">Xem thêm</router-link>
                </p>
            </div>
            <div class="wrapper_idol_live_home wrapper_idol_live_home1" v-if="listLiveidol18.length > 0" style="display: none;">
                <div class="title_item_idol">
                    <h3>
                        <img src="../assets/images/18.png" alt="">
                        <span>Đang show 18+</span>
                        <router-link to="/idol-show">Xem thêm</router-link>
                    </h3>
                </div>
                <div class="root_item_idol">
                    <Carousel :wrap-around="false" :breakpoints="breakpoints">
                        <Slide v-for="(item, indexs) in listLiveidol18.slice(0,10)" :key="indexs">
                            <div class="item_live item_live_97">
                                <router-link v-bind:to="{ name: 'LiveDetailShow_nm', params: { id: item.id, idlive: item.id_live } }" @click="getLocalstoragePage">
                                    <div class="img_live">
                                        <img :src="link_web + item.background" alt="" v-if="item.background != null">
                                        <img src="../assets/images/lv.png" alt="" v-else>
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="link_web + item.hinh_anh" alt="" v-if="item.hinh_anh != null">
                                            <img src="../assets/images/gx.png" alt="" v-else>
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item.fullname }}</h3>
                                            <div class="type_live">
                                                <p>
                                                    <img src="../assets/images/eye.svg" alt="">
                                                    <span class="sp-02">{{ item.view }}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <img src="../assets/images/live.png" alt="" class="img_live_green">
                                    </div>
                                </router-link>
                            </div>
                        </Slide>
                        <template #addons>
                            <Pagination />
                        </template>
                    </Carousel>
                </div>
                <div class="list_idol_mobile_live">
                    <div class="row">
                        <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" v-for="(item, index) in listLiveidol18.slice(0,6)" :key="index">
                            <div class="item_live">
                                <router-link v-bind:to="{ name: 'LiveDetailShow_nm', params: { id: item.id, idlive: item.id_live } }" @click="getLocalstoragePage">
                                    <div class="img_live">
                                        <img :src="link_web + item.background" alt="" v-if="item.background != null">
                                        <img src="../assets/images/lv.png" alt="" v-else>
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="link_web + item.hinh_anh" alt="" v-if="item.hinh_anh != null">
                                            <img src="../assets/images/gx.png" alt="" v-else>
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item.fullname }}</h3>
                                            <div class="type_live">
                                                <p>
                                                    <img src="../assets/images/eye.svg" alt="">
                                                    <span class="sp-02">{{ item.total_view }}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="detail_mobile_a">
                    <router-link to="/idol-show">Xem thêm</router-link>
                </p>
            </div>
            <!-- Idol bg -->
            <div class="wrapper_idol_live_home wrapper_idol_live_home2" v-if="listIdolbg.length > 0">
                <div class="title_item_idol">
                    <h3>
                        <img src="../assets/images/ddx.png" alt="">
                        <span>Idol</span>
                    </h3>
                </div>
                <div class="list_idol_mobile_live_xnxx">
                    <div class="row">
                        <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" v-for="(item, index) in listIdolbg.slice(0,10)" :key="index">
                            <div class="item_live">
                                <router-link v-bind:to="{ name: 'DetailLiveBG_nm', params: { id: item.bigo_id } }" @click="getLocalstoragePage">
                                    <div class="img_live">
                                        <img :src="item.cover_l" alt="">
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="item.data1" alt="">
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item.nick_name.substring(0, 8) }}</h3>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="detail_mobile_live">
                    <!-- <a @click="showModal = true">Xem thêm</a> -->
                    <router-link to="/idol-live">Xem thêm</router-link>
                </p>
            </div>
            <!-- Free -->
            <div class="wrapper_idol_live_home wrapper_idol_live_home2" style="display: none !important;">
                <div class="title_item_idol">
                    <h3>
                        <img src="../assets/images/ddx.png" alt="">
                        <span>Free</span>
                    </h3>
                </div>
                <div class="list_idol_mobile_live_xnxx wp_item_mobile_show">
                    <div class="row">
                        <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" :class="{nn_dtop: index==2}" v-for="(item, index) in listLiveAsian1.slice(0,3)" :key="index">
                            <div class="item_live">
                                <router-link v-bind:to="{ name: 'DetailAsian_nm', params: { id: item[0], free: 1} }" @click="getLocalstoragePage">
                                    <div class="img_live">
                                        <img :src="item[1]" alt="">
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="item[1]" alt="">
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item[2].substring(0, 10) }}</h3>
                                        </div>
                                        <img :src="item[3]" alt="" class="img_live_green">
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" :class="{nn_im_dt: index < 3}" v-for="(item, index) in listLiveidol1.slice(0,6)" :key="index">
                            <div class="item_live">
                                <router-link v-bind:to="{ name: 'DetailVideoPropose_nm', params: { id: item[0], free: 1} }" @click="getLocalstoragePage">
                                    <div class="img_live">
                                        <img :src="item[1]" alt="">
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="item[1]" alt="">
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item[2].substring(0, 10) }}</h3>
                                        </div>
                                        <img :src="item[3]" alt="" class="img_live_green">
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Live Game -->
            <div class="wrapper_idol_live_home wrapper_idol_live_home2" v-if="listLiveGame.length > 0" style="display: none !important;">
                <div class="title_item_idol">
                    <h3>
                        <img src="../assets/images/ddx.png" alt="">
                        <span>Live game</span>
                    </h3>
                </div>
                <div class="list_idol_mobile_live_xnxx">
                    <div class="row">
                        <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" v-for="(item, index) in listLiveGame.slice(0,10)" :key="index">
                            <div class="item_live">
                                <router-link v-bind:to="{ name: 'DetailGame_nm', params: { id: item.bigo_id } }" @click="getLocalstoragePage">
                                    <div class="img_live">
                                        <img :src="item.cover_l" alt="">
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="item.data1" alt="">
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item.nick_name.substring(0, 8) }}</h3>
                                            <div class="type_live">
                                                <p>
                                                    <img src="../assets/images/eye.svg" alt="">
                                                    <span class="sp-02">{{ item.user_count }}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="detail_mobile_live">
                    <!-- <a @click="showModal = true" v-if="token==null">Xem thêm</a> -->
                    <router-link to="/live-game">Xem thêm</router-link>
                </p>
            </div>
            <!-- 18+ -->
            <div class="wrapper_idol_live_home wrapper_idol_live_home2" v-if="listLiveidol.length > 0">
                <div class="title_item_idol">
                    <h3>
                        <img src="../assets/images/ddx.png" alt="">
                        <span>Live show 18+</span>
                    </h3>
                </div>
                <div class="list_idol_mobile_live_xnxx">
                    <div class="row">
                        <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" v-for="(item, index) in listLiveidol.slice(0,10)" :key="index">
                            <div class="item_live">
                                <router-link v-bind:to="{ name: 'DetailVideoPropose_nm', params: { id: item[0], free: 0} }" @click="getLocalstoragePage">
                                    <div class="img_live">
                                        <img :src="item[1]" alt="">
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="item[1]" alt="">
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item[2].substring(0, 10) }}</h3>
                                        </div>
                                        <img :src="item[3]" alt="" class="img_live_green">
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="detail_mobile_live">
                    <!-- <a @click="showModal = true" v-if="token==null">Xem thêm</a> -->
                    <router-link to="/video-propose">Xem thêm</router-link>
                </p>
            </div>
            <!-- Asian -->
            <div class="wrapper_idol_live_home wrapper_idol_live_home2" v-if="listLiveAsian.length > 0">
                <div class="title_item_idol">
                    <h3>
                        <img src="../assets/images/ddx.png" alt="">
                        <span>Asian</span>
                    </h3>
                </div>
                <div class="list_idol_mobile_live_xnxx">
                    <div class="row">
                        <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" v-for="(item, index) in listLiveAsian.slice(0,10)" :key="index">
                            <div class="item_live">
                                <router-link v-bind:to="{ name: 'DetailAsian_nm', params: { id: item[0], free: 0} }" @click="getLocalstoragePage">
                                    <div class="img_live">
                                        <img :src="item[1]" alt="">
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="item[1]" alt="">
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item[2].substring(0, 10) }}</h3>
                                        </div>
                                        <img :src="item[3]" alt="" class="img_live_green">
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="detail_mobile_live">
                    <!-- <a @click="showModal = true" v-if="token==null">Xem thêm</a> -->
                    <router-link to="/asian">Xem thêm</router-link>
                </p>
            </div>
            <!-- Idol follow -->
            <div class="wrapper_idol_live_home wrapper_idol_live_home2" v-if="listFollowidol.length > 0 && token != null">
                <div class="title_item_idol">
                    <h3>
                        <img src="../assets/images/ddx.png" alt="">
                        <span>Idol follow</span>
                    </h3>
                </div>
                <div class="list_idol_mobile_live_xnxx">
                    <div class="row">
                        <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" v-for="(item, index) in listFollowidol.slice(0,10)" :key="index">
                            <div class="item_live">
                                <router-link v-bind:to="{ name: 'DetailVideoPropose_nm', params: { id: item.live_id, free: 0} }" @click="getLocalstoragePage" v-if="item.is_live==1">
                                    <div class="img_live">
                                        <img :src="item.avatar" alt="">
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="item.avatar" alt="">
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item.username.substring(0, 10) }}</h3>
                                        </div>
                                    </div>
                                </router-link>
                                <a @click="offlineIdol" v-else style="cursor: pointer;">
                                    <div class="img_live">
                                        <img :src="item.avatar" alt="">
                                        <div class="hover_icon">
                                            <font-awesome-icon icon="fa-solid fa-caret-right" />
                                        </div>
                                    </div>
                                    <div class="text_item_live">
                                        <div class="img_live_small">
                                            <img :src="item.avatar" alt="">
                                        </div>
                                        <div class="text_live_small">
                                            <h3>{{ item.username.substring(0, 10) }}</h3>
                                        </div>
                                    </div>
                                </a>
                                <div class="unfollow">
                                    <img src="../assets/images/unfl.png" alt="" @click="cancelFolow($event)" :data_name="item.username">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="detail_mobile_live">
                    <router-link to="/list-idol-follow">Xem thêm</router-link>
                </p>
            </div>
        </div>
        <!-- modal login -->
        <div id="modal-example" class="modal-login">
            <div class="overlay" v-if="showModal" @click="showModal = false"></div>
            <div class="modal" v-if="showModal">
                <div class="wp-modal-login">
                    <div class="header-modal">
                        <button class="close-modal_login" @click="showModal = false"><img src="../assets/images/close_md.png" alt=""></button>
                    </div>
                    <div class="content-modal_tab">
                        <Login_f8 @showMd="showModalrg" />
                    </div>
                </div>
            </div>
        </div>
        <!-- end modal login -->
        <!-- modal register -->
        <div id="modal-example" class="modal-login">
            <div class="overlay" v-if="showModal_dk" @click="showModal_dk = false"></div>
            <div class="modal" v-if="showModal_dk">
                <div class="wp-modal-register">
                    <div class="header-modal">
                        <button class="close-modal_login" @click="showModal_dk = false"><img src="../assets/images/close_md.png" alt=""></button>
                    </div>
                    <div class="content-modal_tab">
                        <Register_f8 @showMd="showModallg"/>
                    </div>
                </div>
            </div>
        </div>
        <!-- end modal register -->
        <!-- modal thông báo -->
        <div id="modal-example" class="modal-login">
            <div class="overlay" v-if="showmodal_noti" @click="showmodal_noti = false"></div>
            <div class="modal modal_info" v-if="showmodal_noti">
                <div class="wp-modal-info">
                    <a :href="linkBanner" target="_blank">
                        <img src="../assets/images/gift.png" alt="">
                    </a>
                    <button class="close-modal_login close_gift" @click="hidden_pp"><img src="../assets/images/closegf.png" alt=""></button>
                </div>
            </div>
        </div>
        <!-- end modal thông báo -->
        <!-- modal popup -->
        <div id="modal-example" class="modal-login">
            <div class="overlay" v-if="showmodal_popup" @click="showmodal_popup = false"></div>
            <div class="modal modal_popup" v-if="showmodal_popup">
                <div class="wp_modal_popup">
                    <div class="title_modal">
                        <h2>GK88 - CHƠI GIẢI TRÍ, THƯỞNG NGHÌN TỶ</h2>
                    </div>
                    <div class="content_modal">
                        <img src="../assets/images/pp.png" alt="">
                        <div class="text_modal">
                            <p><img src="../assets/images/images/0.png" class="imgpp0" alt=""> SIÊU KHUYẾN MÃI <img src="../assets/images/images/4.png" class="imgpp4" alt=""> - ƯU ĐÃI KHỦNG LÊN TỚI HÀNG NGHÌN TỶ ĐỒNG !</p>
                            <p><img src="../assets/images/images/1.png" class="imgpp1" alt=""> TẶNG CODE LÊN ĐẾN 888K DÀNH CHO TẤT CẢ KHÁCH HÀNG!</p>
                            <p><img src="../assets/images/images/1.png" class="imgpp1" alt=""> Đăng ký mới - Nhận ngay 39.000đ trải nghiệm miễn phí!</p>
                            <p><img src="../assets/images/images/1.png" class="imgpp1" alt=""> BẮN CÁ - NỔ HŨ cực đỉnh | Nạp lần đầu tặng 100% giá trị!</p>
                            <p><img src="../assets/images/images/1.png" class="imgpp1" alt=""> Bao lì xì khủng mỗi tối 20:00 - Nhận ngay may mắn!</p>
                            <p><img src="../assets/images/images/1.png" class="imgpp1" alt=""> Ngày Vàng 10, 20, 30 hàng tháng - Khuyến mãi 6%</p>
                            <p><img src="../assets/images/images/1.png" class="imgpp1" alt=""> Phát thưởng cực lớn vào ngày 9 - 19 - 29 mỗi tháng!</p>
                            <p><img src="../assets/images/images/1.png" class="imgpp1" alt=""> Tải app GK88 - Tặng ngay 88K miễn phí!</p>
                            <p><img src="../assets/images/images/2.png" class="imgpp2" alt=""> Không giới hạn số lượng người tham gia</p>
                            <p><img src="../assets/images/images/2.png" class="imgpp2" alt=""> Áp dụng cho tất cả hội viên </p>
                            <p><img src="../assets/images/images/2.png" class="imgpp2" alt=""> Càng chơi càng trúng lớn</p>
                            <p><img src="../assets/images/images/3.png" class="imgpp3" alt=""> Tham gia ngay tại <img src="../assets/images/images/4.png" class="imgpp4" alt=""> - Cổng game uy tín, đậm chất giải trí!</p>
                            <p><img src="../assets/images/images/5.gif" class="imgpp5" alt=""> Đường LINK chính thức: <a href="https://gk88.date" target="_blank">GK88.DATE</a></p>
                            <p><img src="../assets/images/images/6.png" class="imgpp6" alt=""> Các kênh TELEGRAM chính thức tại: <a href="https://t.me/addlist/lmv86ZIKRIA1MzU1" target="_blank">TẠI ĐÂY!</a></p>
                            <p><img src="../assets/images/images/7.png" class="imgpp7" alt=""> <a href="https://www.facebook.com/thongbaokhuyenmaigk88/" target="_blank">TẠI ĐÂY</a> & <a href="https://www.facebook.com/gk88fanpagechinhthuc/" target="_blank">TẠI ĐÂY</a></p>
                            <p><img src="../assets/images/images/3.png" class="imgpp3" alt=""> NHẬN CODE SHARE MIỄN PHÍ: <a href="https://t.me/gk88codefree_bot" target="_blank">TẠI ĐÂY</a></p>
                            <p><img src="../assets/images/images/8.png" class="imgpp8" alt=""> LINK NHẬN CODE VIP: <a href="https://gk88codevip.com" target="_blank">gk88codevip.com <img src="../assets/images/images/8.png" class="imgpp8" alt=""></a></p>
                            <p><img src="../assets/images/images/9.png" class="imgpp9" alt=""> DỊCH VỤ TƯ VẤN 24/7: <a href="https://t.me/GK88HOTRO24H_BOT" target="_blank">https://t.me/GK88HOTRO24H_BOT</a></p>
                            <p><img src="../assets/images/images/11.png" class="imgpp10" alt=""> Chơi Ngay Trên App: <a href="https://t.me/GK88TRANGCHU_BOT" target="_blank">https://t.me/GK88TRANGCHU_BOT</a></p>
                            <p><img src="../assets/images/images/8.png" class="imgpp8" alt=""> LINK ĐĂNG KÍ NHẬN KHUYẾN MÃI: <a href="https://khuyenmai-gk88.pages.dev" target="_blank">https://khuyenmai-gk88.pages.dev</a></p>
                        </div>
                    </div>
                    <button class="closeMd_pp" @click="showmodal_popup = false">Đóng</button>
                </div>
            </div>
        </div>
        <!-- end modal popup -->
    </div>
</template>

<script>
import Login_f8 from '@/components/Login'
import Register_f8 from '@/components/Register'
import HLSCore from '@cloudgeek/playcore-hls'
import { Carousel, Slide, Pagination } from 'vue3-carousel'
import $ from 'jquery'
export default {
    name: 'Home_live',
    setup() {
		return {
			breakpoints: {
                0: {
					itemsToShow: 1.5,
					snapAlign: "start"
				},
				431: {
					itemsToShow: 2,
					snapAlign: "start"
				},
				768: {
					itemsToShow: 3,
					snapAlign: "start"
				},
				1024: {
					itemsToShow: 3,
					snapAlign: "start"
				},
                1280: {
					itemsToShow: 4,
					snapAlign: "start"
				},
			}
		};
	},
    data () {
        return {
            showmodal_noti: false,
            showModal: false,
            showModal_dk: false,
            tabSelected: 'livegame',
            liveRoom: [],
            players: {},
            volume: 90,
            HLSCore,
            check: 0,
            listLive: [],
            listLiveHome: [],
            listLiveidol18: [],
            token: window.localStorage.getItem('token'),
            rank: window.localStorage.getItem('rank'),
            checkes: '',
            listBxhs: [],
            listIdolAll: [],
            listIdol18All: [],
            hot_idol: [],
            typeus: window.localStorage.getItem('typeus'),
            numberus: parseInt(window.localStorage.getItem('numberus')),
            type_live: parseInt(window.localStorage.getItem('type_live')),
            other: '',
            length_hot: 6,
            lenghVideo: 12,
            listGift: [],
            listIdolAll1: [],
            listIdol18All1: [],
            hot_idol1: [],
            country: 'Vietnam',
            linkBanner: '',
            check_deveci: 1,
            linkgame: '',
            listLiveidol: [],
            listLiveidol1: [],
            listItemdate1: [],
            tabSelectedpl: '',
            tabs: '',
            checkMobile: 0,
            showmodal_popup: false,
            listFollowidol: [],
            listLiveAsian: [],
            listLiveAsian1: [],
            listIdolbg: [],
            listLiveGame: [],
            checkClickAdv: 0
        }
    },
    components: {
        Carousel,
        Slide,
        Pagination,
        Login_f8,
        Register_f8,
    },
    mounted () {
        this.$nextTick(() => {
        })
        let isMobile = /Mobi/i.test(navigator.userAgent)
        if(isMobile == true){
            this.checkMobile = 1
        }
        let ss = sessionStorage.getItem("session");
        if(this.token == null && ss == null){
            var title_ss = 'user0';
            var num_ran = Math.floor(Math.random() * 1000000000);
            var session = title_ss + num_ran
            sessionStorage.setItem("session", session);
        }
    },
    created () {
        this.getDataRoomLive()
        this.getDataliveidol18()
        this.getListBxhs()
        this.getDataListGift()
        this.getlocation()
        this.getInfoLink()
        this.getDataliveidolApi()
        setTimeout(() => {
            this.showmodal_popup = true
        }, 500);
        if(this.token != null){
            sessionStorage.clear();
            this.getListFollow()
        }
        this.getDataliveAsian()
        this.getDataliveidolBg()
        this.getDataliveGame()
        setTimeout(() => {
            $('.nextvideo').show()
        }, 5000);
    },
    computed: {
        loadMore_hotidol() {
            return this.hot_idol.slice(0, this.length_hot);
        },
    },
    methods: {
        getInfoLink () {
            this.axios.get(this.api_previewLink + '?domain=' + this.url_param).then((response) => {
                this.linkBanner = response.data.data.list_data.banner
                this.linkgame = response.data.data.list_data.link_game;
            })
        },
        showlogin () {
            this.$swal({
                position: 'top-end',
                icon: 'error',
                title: 'Vui lòng đăng nhập',
                showConfirmButton: false,
                timer: 3000
            })
        },
        getDataRoomLive () {
            this.axios.get(this.api_listlive).then((response) => {
                this.listLiveHome = response.data.data.list_user
                if(this.listLiveHome.length > 0){
                    let check_deveci = this.listLiveHome[0].device
                    if(check_deveci == 1){
                        this.check_deveci = 1
                    }else{
                        this.check_deveci = 2
                    }
                }
            })
        },
        getDataliveidol18 () {
            this.axios.get(this.api_listall).then((response) => {
                this.listLiveidol18 = response.data.data.list_user.filter(d => d.type_live === 2 && d.live === 1)
                this.hot_idol = this.shuffle(response.data.data.list_user)
                this.hot_idol1 = response.data.data.list_user
            })
        },
        loadMore() {
            if (this.length_hot > this.hot_idol.length) return;
            this.length_hot = this.length_hot + 6;
        },
        searchIdolHot (e) {
            e.preventDefault()
            let keyname = $('.key_searchIdol').val().toLowerCase()
            let dataArray = []
            $.each(this.hot_idol1, function() {
                if ( this.fullname.toLowerCase().indexOf(keyname) != -1) {
                    return dataArray.push(this);
                }
            });
            this.hot_idol = dataArray
        },
        getDataliveidolApi () {
            this.axios.get(this.api_live18_dexuat).then((response) => {
                this.listLiveidol1 = response.data.data.filter(d => d[4] == 200 && d[6] == 1)
                let isMobile = /Mobi/i.test(navigator.userAgent)
                if(isMobile == true){
                    this.listLiveidol = this.shuffle(response.data.data.filter(d => d[4] == 200 && d[6] == 1))
                }else{
                    this.listLiveidol = this.shuffle(response.data.data.filter(d => d[6] == 1))
                }
            })
        },
        viewCore(id, player) {
            this.players[id] = player;
            this.play(id)
        },
        viewCores(id, player) {
            this.players[id] = player;
        },
        play(id) {
            this.players && this.players[id] && this.players[id].play();
        },
        pip(id) {
            this.players &&
            this.players[id] &&
            this.players[id].requestPictureInPicture();
        },
        retrieveAllCustomer (url) {
            this.axios.get(url).then(res => {
                if(res.status===200){
                    this.check = 1
                }
            }).catch(e => {
                if (e.response.status === 404) {
                    this.check = 0
                }else{
                    this.check = 1
                }
            })
            return this.check;
        },
        getListBxhs () {
            this.axios.get(this.api_rankfollow).then((response) => {
                this.listBxhs = response.data.data.list_user.slice(0, 9)
            })
        },
        seandMbut (id) {
            if(id != null){
                this.axios.post(this.api_offstream, {
                    id: id,
                }).then(res => {
                    this.other = res
                }).catch(e => {
                    this.other = e
                })
            }
        },
        hidden_pp () {
            this.showmodal_noti = false
            this.$cookies.set(100, 'close', "600s");
        },
        getDataListGift () {
            this.axios.get(this.api_listGift).then((response) => {
                this.listGift = response.data.data.list_data
                if(this.listGift.length > 0 && this.$cookies.get(100) !== 'close'){
                    setTimeout(() => {
                        this.showmodal_noti = true
                    }, 3000);
                }
            })
        },
        getlocation () {
            this.axios.get('https://geolocation-db.com/json/').then((response) => {
                this.country = response.data.country_name
            })
        },
        viewmodal_rg () {
            this.showModal_dk = true
            this.showModal = false
        },
        viewmodal_lg () {
            this.showModal = true
            this.showModal_dk = false
        },
        changeTab (tab) {
            this.tabSelected = tab
        },
        changeTabpl (tab) {
            this.tabSelectedpl = tab
            this.tabs = tab
        },
        shuffle(arra1) {
            var ctr = arra1.length, temp, index;
            while (ctr > 0) {
                index = Math.floor(Math.random() * ctr);
                ctr--;
                temp = arra1[ctr];
                arra1[ctr] = arra1[index];
                arra1[index] = temp;
            }
            return arra1;
        },
        getLocalstoragePage () {
            window.localStorage.setItem('hiddenhd', 1)
            $('#app').addClass('hideheader')
        },
        clickPlaypp () {
            this.showModal_dk = true
            this.showmodal_popup = false
        },
        getListFollow () {
            this.axios.get(this.api_listfollow,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.listFollowidol = response.data.data
            })
        },
        offlineIdol () {
            this.$swal({
                position: 'top-end',
                icon: 'error',
                title: 'Idol hiện tại đã kết thúc phiên live',
                showConfirmButton: false,
                timer: 3000
            })
        },
        cancelFolow (event) {
            event.preventDefault()
            $('.loading_show').show().fadeIn(10)
            var nameidol = event.target.getAttribute('data_name')
            this.axios.post(this.api_followidol, {
                    name_idol: nameidol,
                    type: 0
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then(res => {
                $('#loading_show').css('display', 'none')
                this.getListFollow()
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: res.data.message,
                    showConfirmButton: false,
                    timer: 4000
                })
            }).catch(e => {
                $('#loading_show').css('display', 'none')
                if(e.response.status === 404){
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: e.response.data.message,
                        showConfirmButton: false,
                        timer: 3000
                    })
                }
            })
        },
        getDataliveAsian () {
            this.axios.get(this.api_listAsian).then((response) => {
                this.listLiveAsian = this.shuffle(response.data.data.filter(d => d[4] == 200 && d[6] == 1));
                this.listLiveAsian1 = response.data.data.filter(d => d[4] == 200 && d[6] == 1);
            })
        },
        getDataliveidolBg () {
            this.axios.get(this.api_listBG).then((response) => {
                this.listIdolbg = this.shuffle(response.data.data)
            })
        },
        showModalrg () {
            this.showModal = false
            this.showModal_dk = true
        },
        showModallg () {
            this.showModal = true
            this.showModal_dk = false
        },
        getDataliveGame () {
            this.axios.get(this.api_ListGameBG).then((response) => {
                this.listLiveGame = this.shuffle(response.data.data.data)
            })
        },
        nextVideo () {
            this.checkClickAdv = 1
        },
        replaceName (str) {
            return str.replaceAll('-', ' ')
        },
        convertDatetime(d) {
            let gt7 = 7 * 3600
            let timeStamp_change = Number(d) + gt7
            return new Date(timeStamp_change * 1000).toISOString().slice(0, 19).replace('T', ' ')
        },
        convertDateStame (d) {
            let arr = d.split(' ')
            let ngaythang = arr[0]
            let arrNt = ngaythang.split('-')
            let giophut = arr[1]
            let arrGp = giophut.split(':')
            return arrNt[2] + '/' + arrNt[1] + ' ' + arrGp[0] + ':' + arrGp[1]
        },
    }
}
</script>